<script>
  import { Card } from 'attractions'
</script>

<Card outline>
  <div class="api command">addDropCommand()</div>
  Instructs the robot to drop a game piece onto the playing surface.
  <div class="api title">Arguments:</div>
  <ul>
    <li>[none]</li>
  </ul>
  <div class="api title">Constraints:</div>
  <ul>
    <li>[none]</li>
  </ul>
  <div class="api title">Example:</div>
  <div class="api code">
    <pre>
      robot.addDropCommand();
    </pre>
  </div>
</Card>
